import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/freshsales-crm.vue
var o = {
	name: "DtIconFreshsalesCrm",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--freshsales-crm"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Freshsales Crm",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M20 2.067h-8.813a9.62 9.62 0 0 0-4.074 1.266 9.9 9.9 0 0 0-4.993 8.46c0 9.047 9.027 10.067 9.027 10.067S18.6 23.28 21.64 14.2c.143-.444.217-.907.22-1.373l.073-8.947A3.227 3.227 0 0 0 20 2.067Z",
		fill: "#FFA800"
	}, null, -1), r("path", {
		d: "M12.1 10.927a1.947 1.947 0 1 0 0-3.894 1.947 1.947 0 0 0 0 3.894Zm-4.367.733h8.527l-3.393 3.407-.027 1.9h-1.687v-1.914l-3.42-3.393Z",
		fill: "#fff"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=freshsales-crm.js.map